function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      ).muted;
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    if (document.body.classList.contains('template-product') && window.innerWidth < 768) {
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      if (!this.sliderControlWrapper) return;

      this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
      this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
      );
      this.sliderControlLinksArray.forEach((link) =>
        link.addEventListener('click', this.linkToSlide.bind(this)),
      );
    }

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (document.body.classList.contains('template-product') && window.innerWidth < 768) {
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');

      if (!this.sliderControlButtons.length) return;

      this.sliderControlButtons.forEach((link) => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
      this.sliderControlButtons[this.currentPage - 1].parentElement.scrollTo({
        left: this.sliderControlButtons[this.currentPage - 1].offsetLeft,
      });
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (event.target.classList.contains('no-update')) {
      this.updateOptionsFabric(event);
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionsFabric(event) {
    const options = event.target
      .closest('.product-form__input-fabric')
      .querySelectorAll('input.no-update');
    for (const item of options) {
      item.removeAttribute('checked');
      item.closest('.mini-card-option').classList.remove('active');
    }
    event.target.setAttribute('checked', 'true');
    event.target.closest('.mini-card-option').classList.add('active');
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationConfiguratorSummary = document.querySelector(
          `.configurator-${this.dataset.section} .mobile-facets__open-wrapper`,
        );
        const destinationStock = document.getElementById(`stock-${this.dataset.section}`);
        const destinationGallery = document.querySelector(
          `.product__media-wrapper-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const sourceConfiguratorSummary = html.querySelector(
          `.configurator-${this.dataset.section} .mobile-facets__open-wrapper`,
        );
        const sourceStock = html.getElementById(`stock-${this.dataset.section}`);
        const sourceStockProperty = html.getElementById(`stock-property-${this.dataset.section}`);
        const destinationStockProperty = document.getElementById(
          `stock-property-${this.dataset.section}`,
        );
        const sourceGallery = html.querySelector(`.product__media-wrapper-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceConfiguratorSummary && destinationConfiguratorSummary)
          destinationConfiguratorSummary.innerHTML = sourceConfiguratorSummary.innerHTML;
        if (sourceStock && destinationStock) destinationStock.innerHTML = sourceStock.innerHTML;

        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const sourceCarac = html.getElementById(`caracteristiques-${sectionId}`);
        const destinationCarac = document.getElementById(`caracteristiques-${sectionId}`);
        if (sourceCarac && destinationCarac) destinationCarac.innerHTML = sourceCarac.innerHTML;

        const sourceOptionInfo = html.getElementById(`option-info-${sectionId}`);
        const destinationOptionInfo = document.getElementById(`option-info-${sectionId}`);
        if (sourceOptionInfo && destinationOptionInfo) destinationOptionInfo.innerHTML = sourceOptionInfo.innerHTML;
        if (sourceStockProperty && destinationStockProperty)
          destinationStockProperty.outerHTML = sourceStockProperty.outerHTML;

        // Barre sticky : son prix/titre ne sont pas inclus dans #price-{section},
        // il faut les synchroniser à part (sinon le sticky reste sur l'ancienne variante)
        const stickyPriceSource = html.querySelector(`#sticky-bar-${sectionId} .sticky-bar__price`);
        const stickyPriceDest = document.querySelector(`#sticky-bar-${this.dataset.section} .sticky-bar__price`);
        if (stickyPriceSource && stickyPriceDest) stickyPriceDest.outerHTML = stickyPriceSource.outerHTML;

        const stickyTitleSource = html.querySelector(`#sticky-bar-${sectionId} .sticky-title_product`);
        const stickyTitleDest = document.querySelector(`#sticky-bar-${this.dataset.section} .sticky-title_product`);
        if (stickyTitleSource && stickyTitleDest) stickyTitleDest.innerHTML = stickyTitleSource.innerHTML;
        if (sourceGallery && destinationGallery) {
          destinationGallery.innerHTML = sourceGallery.innerHTML;
          // Déclencher un événement pour signaler que la galerie a été mise à jour
          document.dispatchEvent(new CustomEvent('gallery:updated', {
            detail: { sectionId: this.dataset.section, variant: this.currentVariant }
          }));
        }

        // Suggestions « Nos recommandations » (retour km.gouma 07/07) : la variante
        // sélectionnée doit toujours passer en carte #1 encadrée, les autres en stock
        // en dessous dans leur ordre canonique. Le rendu serveur applique déjà cet
        // ordre → on resynchronise la liste complète à chaque changement, pour un
        // comportement identique sur tous les produits (ex. Cocoon comme Ouessant).
        const suggestionsList = this.closest('product-suggestions')?.querySelector('.suggestions__list');
        const sourceSuggestionsList = html.querySelector('product-suggestions .suggestions__list');
        if (suggestionsList && sourceSuggestionsList) {
          suggestionsList.innerHTML = sourceSuggestionsList.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  renderProductFabric(event) {
    const optionActive = event.target
      .closest('.mobile-facets__main')
      .querySelector('.product-form__input-fabric input[checked]');

    if (window.location.pathname === optionActive.getAttribute('data-url-without-variant')) {
      !event.target.classList.contains('js-drawer-update')
        ? event.target.closest('.option-drawer').querySelector('summary').click()
        : event.target.closest('menu-drawer').onDrawerChange(event);
      return;
    }

    event.target.classList.add('loading');
    event.target.setAttribute('disabled', 'true');
    event.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    fetch(
      `${optionActive.dataset.url}&section_id=${this.closest('variant-radios').dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const sectionId = this.closest('variant-radios').dataset.section;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${sectionId}`);
        const destinationGallery = document.querySelector(`.product__media-wrapper-${sectionId}`);
        const destinationTitle = document.querySelector(`.product__title-${sectionId}`);
        const destinationSubTitle = document.querySelector(`.product__sub_title-${sectionId}`);
        const destinationStockSummary = document.querySelector(`.stock-${sectionId}`);
        const destinationConfiguratorSummary = document.querySelector(
          `.configurator-${sectionId} .mobile-facets__open-wrapper`,
        );
        const destinationForm = document.querySelector(`.buy_buttons-${sectionId}`);
        const destinationVariantsScript = document.querySelector(
          `.product__variants-script-${sectionId}`,
        );
        const destinationNoScriptForm = document.querySelector(
          `.product-form__noscript-wrapper-${sectionId}`,
        );
        const destinationFormInstallment = document.getElementById(
          `product-form-installment-${sectionId}`,
        );
        const destinationStock = document.getElementById(`stock-${sectionId}`);
        const destinationReassurances = document.querySelector(
          `.product__reassurances-${sectionId}`,
        );
        const source = html.getElementById(`price-${sectionId}`);
        const sourceGallery = html.querySelector(`.product__media-wrapper-${sectionId}`);
        const sourceTitle = html.querySelector(`.product__title-${sectionId}`);
        const sourceSubTitle = html.querySelector(`.product__sub_title-${sectionId}`);
        const sourceConfiguratorSummary = html.querySelector(
          `.configurator-${sectionId} .mobile-facets__open-wrapper`,
        );
        const sourceStockSummary = html.querySelector(`.stock-${sectionId}`);
        const sourceForm = html.querySelector(`.buy_buttons-${sectionId}`);
        const sourceVariantsScript = html.querySelector(`.product__variants-script-${sectionId}`);
        const sourceNoScriptForm = html.querySelector(
          `.product-form__noscript-wrapper-${sectionId}`,
        );
        const sourceFormInstallment = html.getElementById(`product-form-installment-${sectionId}`);
        const sourceStock = html.getElementById(`stock-${sectionId}`);
        const sourceReassurances = html.querySelector(`.product__reassurances-${sectionId}`);
        const destinationConfiguratorWrapper = document.querySelectorAll(
          `.configurator-${sectionId} .mobile-facets__inner-wrapper:not(.mobile-facets__inner-wrapper-fabric) .mobile-facets__wrapper`,
        );
        const sourceConfiguratorWrapper = html.querySelectorAll(
          `.configurator-${sectionId} .mobile-facets__inner-wrapper:not(.mobile-facets__inner-wrapper-fabric) .mobile-facets__wrapper`,
        );
        const sourceStockProperty = html.getElementById(`stock-property-${sectionId}`);
        const destinationStockProperty = document.getElementById(`stock-property-${sectionId}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceVariantsScript && destinationVariantsScript)
          destinationVariantsScript.innerHTML = sourceVariantsScript.innerHTML;
        if (sourceConfiguratorSummary && destinationConfiguratorSummary)
          destinationConfiguratorSummary.innerHTML = sourceConfiguratorSummary.innerHTML;
        if (sourceStockSummary && destinationStockSummary)
          destinationStockSummary.innerHTML = sourceStockSummary.innerHTML;
        if (sourceForm && destinationForm) destinationForm.innerHTML = sourceForm.innerHTML;
        if (sourceStock && destinationStock) destinationStock.innerHTML = sourceStock.innerHTML;
        if (sourceGallery && destinationGallery)
          destinationGallery.innerHTML = sourceGallery.innerHTML;
        if (sourceTitle && destinationTitle) destinationTitle.innerHTML = sourceTitle.innerHTML;
        if (sourceSubTitle && destinationSubTitle)
          destinationSubTitle.innerHTML = sourceSubTitle.innerHTML;
        if (sourceNoScriptForm && destinationNoScriptForm)
          destinationNoScriptForm.innerHTML = sourceNoScriptForm.innerHTML;
        if (sourceFormInstallment && destinationFormInstallment)
          destinationFormInstallment.innerHTML = sourceFormInstallment.innerHTML;
        if (sourceReassurances && destinationReassurances)
          destinationReassurances.innerHTML = sourceReassurances.innerHTML;
        if (sourceStockProperty && destinationStockProperty)
          destinationStockProperty.outerHTML = sourceStockProperty.outerHTML;

        const sourceCarac = html.getElementById(`caracteristiques-${sectionId}`);
        const destinationCarac = document.getElementById(`caracteristiques-${sectionId}`);
        if (sourceCarac && destinationCarac) destinationCarac.innerHTML = sourceCarac.innerHTML;

        const sourceOptionInfo = html.getElementById(`option-info-${sectionId}`);
        const destinationOptionInfo = document.getElementById(`option-info-${sectionId}`);
        if (sourceOptionInfo && destinationOptionInfo) destinationOptionInfo.innerHTML = sourceOptionInfo.innerHTML;

        if (
          this.closest('variant-radios').hasAttribute('data-url') &&
          html.querySelector('variant-radios').hasAttribute('data-url')
        )
          this.closest('variant-radios').setAttribute(
            'data-url',
            html.querySelector('variant-radios').getAttribute('data-url'),
          );

        for (let i = 0; i < destinationConfiguratorWrapper.length; i++) {
          if (sourceConfiguratorWrapper[i] && destinationConfiguratorWrapper[i])
            destinationConfiguratorWrapper[i].innerHTML = sourceConfiguratorWrapper[i].innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        setTimeout(() => {
          this.closest('variant-radios').updateOptions();
          this.closest('variant-radios').updateMasterId();
          this.closest('variant-radios').toggleAddButton(true, '', false);
          this.closest('variant-radios').updatePickupAvailability();
          this.closest('variant-radios').removeErrorMessage();

          if (!this.closest('variant-radios').currentVariant) {
            this.closest('variant-radios').toggleAddButton(true, '', true);
            this.closest('variant-radios').setUnavailable();
          } else {
            this.closest('variant-radios').updateMedia();
            this.closest('variant-radios').updateURL();
            this.closest('variant-radios').updateVariantInput();
            this.closest('variant-radios').renderProductInfo();
            this.closest('variant-radios').updateShareUrl();
          }

          event.target.classList.remove('loading');
          event.target.querySelector('.loading-overlay__spinner').classList.add('hidden');
          event.target.removeAttribute('disabled');

          this.closest('variant-radios').toggleAddButton(
            !this.closest('variant-radios').currentVariant.available,
            window.variantStrings.soldOut,
          );
          this.closest('.product__info-container-desktop')
            .querySelector('product-form')
            .attachListeners();

          !event.target.classList.contains('js-drawer-update')
            ? event.target.closest('.option-drawer').querySelector('summary').click()
            : event.target.closest('menu-drawer').onDrawerChange(event);
        }, 200);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div'),
            htmlSwiper = document.createElement('div'),
            htmlWrapperSwiper = document.createElement('div'),
            htmlBtnPrev = document.createElement('div'),
            htmlBtnNext = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            const ul = recommendations?.querySelector('.product-grid'),
              li = recommendations?.getElementsByTagName('li');
            htmlWrapperSwiper.classList.add('swiper-outer-wrapper');
            htmlSwiper.classList.add('swiper');
            htmlSwiper.setAttribute('id', 'Swiper-product-recommendations');
            recommendations?.querySelector('.product-grid').classList.add('swiper-wrapper');
            htmlBtnPrev.classList.add('swiper-button-prev', 'with-background');
            htmlBtnNext.classList.add('swiper-button-next', 'with-background');

            htmlBtnPrev.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-arrow" fill="none" viewBox="0 0 6 8">
                                    <path stroke="currentColor" stroke-width="1.5" d="m.975 1.157 3 3-3 3"/>
                                    </svg>`;

            htmlBtnNext.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-arrow" fill="none" viewBox="0 0 6 8">
                                    <path stroke="currentColor" stroke-width="1.5" d="m.975 1.157 3 3-3 3"/>
                                    </svg>`;

            for (const item of li) item.classList.add('swiper-slide');

            htmlSwiper.innerHTML = recommendations.querySelector('.product-grid').outerHTML;
            htmlWrapperSwiper.innerHTML = htmlSwiper.outerHTML;
            htmlWrapperSwiper.innerHTML += htmlBtnPrev.outerHTML;
            htmlWrapperSwiper.innerHTML += htmlBtnNext.outerHTML;

            ul.parentNode.replaceChild(htmlWrapperSwiper, ul);

            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            const slider = this?.querySelector('[id^="Swiper-"]'),
              prevButtonEl = this?.querySelector('.swiper-button-prev'),
              nextButtonEl = this?.querySelector('.swiper-button-next');

            if (typeof window.Swiper !== 'function') {
              prevButtonEl.style.display = 'none';
              nextButtonEl.style.display = 'none';
              return;
            }

            var _gridGap = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid-desktop-horizontal-spacing')) || 0;

            new window.Swiper(slider, {
              loop: false,
              spaceBetween: _gridGap,
              autoplay: false,
              effect: 'slide',
              freeMode: true,
              breakpoints: {
                0: {
                  slidesPerView: 1.2,
                  navigation: false,
                },
                768: {
                  slidesPerView: 2.35,
                  navigation: false,
                },
                1200: {
                  grabCursor: false,
                  freeMode: false,
                  slidesPerView: 3,
                  navigation: {
                    prevEl: prevButtonEl,
                    nextEl: nextButtonEl,
                  },
                },
              },
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
